import axios from 'src/utils/axios';
import { URLS } from 'src/utils/url';

class ConsumptionService {

	search(communityId, params) {
		return axios.get(`/api/v1/communities/${communityId}/consumptions`, { params: params });
	}

	getCurves(communityId, params) {
		return axios.get(`/api/v1/communities/${communityId}/curves`, { params: params });
	}
	getDue(communityId, params) {
		return axios.get(`/api/v1/communities/${communityId}/due`, { params: params });
	}

}

const consumptionService = new ConsumptionService();

export default consumptionService;
